function DeleteUserController($scope, user, session, notificationService, $state) {
  $scope.user = user;
  $scope.currentUser = session.user;

  $scope.remove = function(user) {
    user.remove()
      .then(function() {
        notificationService.success('User deleted.');
        $state.go('users');
      })
      .catch(function() {
        notificationService.fail('Failed to delete user.');
      });
  };
}

DeleteUserController.$inject = ['$scope', 'user', 'session', 'notificationService', '$state'];

export default DeleteUserController;



/** WEBPACK FOOTER **
 ** ./src/app/users/delete-user.controller.js
 **/